import * as S from './style';
import { FaBomb } from 'react-icons/fa';

function Title() {
  return (
    <S.TitleContainer>
      <h1>minesweeper</h1>
      <FaBomb />
    </S.TitleContainer>
  );
};

export default Title;
